var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppDialog',{ref:"dialog_container",staticClass:"app-dialog",attrs:{"overflowHidden":"","closeRight":"0","closeTop":"-30","disableMaxWidth":"","dialogName":"SettingsDialog","width":"1300"}},[_c('SettingsRouter',{attrs:{"routeName":_vm.routeName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }